import { useEffect, useMemo } from 'react'
import { useLeague } from './LeagueContext'
import { useSportContext } from './SportContext'
import { tenantSportIds } from './storedSport'

/**
 * Restore the fan's stored sport when the calling component mounts, and again
 * when the tenant's sport ids or default sport change (P0, §6.0). The site
 * chrome calls this where SportSwitcher's restore effect used to be, so the
 * restore keeps today's exact timing: an effect in the commit the chrome
 * mounts in, seeing the active sport that commit rendered with.
 */
export function useStoredSportRestore(): void {
  const { league } = useLeague()
  const { activeSportId, restoreStoredSport } = useSportContext()
  const sports = useMemo(() => tenantSportIds(league), [league])
  useEffect(() => {
    restoreStoredSport({ sports, defaultSportId: league?.default_sport_id, activeSportId })
    // Deps match the switcher's original effect: only the tenant's sport set
    // and default re-trigger it; activeSportId is read from this render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sports.join(','), league?.default_sport_id])
}
